import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, CheckCircle } from 'lucide-react';
import { contactInfo } from '../../data/contact-info';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white text-primary pt-6 pb-4">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h3 className="text-primary text-lg font-bold mb-2">Dietronik-Service e.K.</h3>
            <p className="mb-2 text-sm text-primary">Ihr zuverlässiger Partner für Elektrotechnik und Reparaturdienstleistungen seit vielen Jahren.</p>
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <Phone size={16} className="text-primary" />
                <span className="text-xs text-primary">{contactInfo.phone.display}</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={16} className="text-primary" />
                <span className="text-xs text-primary">{contactInfo.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={16} className="text-primary" />
                <span className="text-xs text-primary">{contactInfo.address.city}, {contactInfo.address.country}</span>
              </div>
            </div>
          </div>

          <div className="text-center md:text-right">
            <h3 className="text-primary text-lg font-bold mb-2">Folgen Sie uns</h3>
            <div className="flex gap-4 justify-center md:justify-end mb-3">
              <a
                href="https://www.facebook.com/share/1G2fWnhAtf/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary hover:scale-110 transition-all duration-300 ease-in-out"
                aria-label="Facebook"
              >
                <Facebook size={28} />
              </a>
              <a
                href="https://www.instagram.com/dietronik_service/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary hover:scale-110 transition-all duration-300 ease-in-out"
                aria-label="Instagram"
              >
                <Instagram size={28} />
              </a>
              <a
                href="https://www.tiktok.com/@dietronik.shop?_t=ZN-8vdOEzcueOc&_r=1"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary hover:scale-110 transition-all duration-300 ease-in-out"
                aria-label="TikTok"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-tiktok"
                >
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
                </svg>
              </a>
              <a
                href="https://handwerk.check24.de/craftsmen/cs/profile/sp_mEnvd"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary hover:scale-110 transition-all duration-300 ease-in-out"
                aria-label="Check24"
              >
                <CheckCircle size={24} />
              </a>
            </div>
            <div className="text-xs text-primary text-right md:mt-9">
              Konzeption & Gestaltung der Seite:{' '}
              <a 
                href="https://di-systems.de" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#D80413] hover:underline transition-all"
              >
                di-Systems
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border/30 mt-4 pt-3 text-center text-xs text-primary">
          <p>© {currentYear} Dietronik-Service e.K. Alle Rechte vorbehalten. | 
            <Link to="/legal" className="hover:text-primary transition-colors ml-1 text-primary">Impressum und Datenschutz</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
